module.exports = __webpack_public_path__ + "facebook-extra-small.ZHguHxRn.svg";